import domContentLoaded from 'dom-content-loaded';
import $, { each } from 'jquery';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel';

export default () => {
	domContentLoaded(() => {
		const $slider = $('.js-slider');
		$slider
			.on({
				init(event, slick, currentSlide, nextSlide) {
					slick.$slides.eq(0).addClass('zooming');
					document.body.classList.remove('is-loading');
				},
				beforeChange(event, slick, currentSlide, nextSlide) {
					slick.$slides.eq(nextSlide).addClass('zooming');
				},
				afterChange(event, slick, currentSlide, nextSlide) {
					slick.$slides.eq(currentSlide - 1).removeClass('zooming');
				},
			})
			.slick({
				dots: false,
				arrows: false,
				fade: true,
				autoplay: true,
				pauseOnHover: false,
				pauseOnFocus: false,
				accessibility: false,
				swipe: false,
				autoplaySpeed: 3000,
				speed: 1000,
			});

		/* モデルハウスのスライダー */
		// const $mhSlider = $('.js-mhSlider');
		const $mhSlides = $('.js-mhSlide');
		const mhSlideLength = $mhSlides.length;
		const zIndex = [];
		let currentNo;
		let nextNo;
		let prevNo;
		currentNo = 0;
		nextNo = 1;

		// 初期処理
		$mhSlides.each((index, elm) => {
			$(elm)
				.css('z-index', mhSlideLength - index)
				.addClass('is-none');
			zIndex[index] = mhSlideLength - index;
		});
		$mhSlides.eq(currentNo).removeClass('is-none').addClass('is-current');
		$mhSlides.eq(nextNo).removeClass('is-none').addClass('is-next');
		// スライド開始
		$(window).on('load', () => {
			setInterval(() => {
				$mhSlides.eq(currentNo).removeClass('is-next').addClass('is-current');
				$mhSlides.eq(nextNo).removeClass('is-none').addClass('is-next');
				$mhSlides.each((index, elm) => {
					$(elm).css('z-index', zIndex[index]);
				});
				setTimeout(() => {
					$mhSlides.eq(currentNo).addClass('is-none').removeClass('is-current');
					// $mhSlides.eq(nextNo).addClass('is-none').removeClass('is-next');
					prevNo += 1;
					currentNo += 1;
					nextNo += 1;
					for (let i = 0; i < zIndex.length; i += 1) {
						zIndex[i] += 1;
						if (zIndex[i] > mhSlideLength) zIndex[i] = 1;
					}
					if (prevNo === mhSlideLength) prevNo = 0;
					if (currentNo === mhSlideLength) currentNo = 0;
					if (nextNo === mhSlideLength) nextNo = 0;
				}, 3000);
			}, 4500);
		});

		// インタビューのスライド
		$('.js-top-interview-slider').slick({
			arrows: true,
			dots: true,
			appendDots: $('.js-top-interview-slider-dots'),
			prevArrow: '<a class="top-interview-arrow top-interview-arrow--prev"></a>',
			nextArrow: '<a class="top-interview-arrow top-interview-arrow--next"></a>',
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [
				{
					breakpoint: 1023,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});

		// イベント情報のスライダー
		$('.js-blogSlider').each((index, elm) => {
			$(elm).slick({
				infinite: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				appendArrows: $('.js-blogSlider-control__' + index),
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
						},
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							centerMode: true,
							centerPadding: '30px',
						},
					},
				],
			});
		});
	});
};
